import React from 'react';
import CommonSourceCard from '@gp/components/CommonSourceCard';
import { getRoundIntegerNum, getNumberOfDotUnit } from '@gp/utils/common';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';

import './index.scss';

import FileIcon from '@gp/assets/svg/gameInformation/file.svg';

const TotalStudioCountsCard: React.FC<ITotalStudioCountsCard> = (props) => {
  const { total, details = [] } = props;

  const isNoData = details?.every((item) => {
    // @ts-ignore
    const temp = Number.parseInt(item?.value, 10);
    return Number.isNaN(temp);
  });

  const renderDetails = () => (
    <ul className="dbg-total-studio-counts-list">
      {details?.length > 0 &&
        details?.map((detail, index) => (
          <li key={index} className="dbg-total-studio-counts-item">
            {detail?.text}: <span className="highlight">{getRoundIntegerNum(detail?.value)}</span>
          </li>
        ))}
    </ul>
  );

  return (
    // @ts-ignore
    <CommonSourceCard
      isTitleMultipleLinesTextBubble
      multipleLinesTextFields={FIELDS1}
      multipleLinesTextFieldNames={FIELD_NAMES}
      multipleLinesTextData={{
        definition: 'Number of all portfolio studios.',
        source: 'Mergers and Acquisitions Team (M&A)',
        updateCadence: 'Ad hoc, update when acquisition completed',
      }}
      title="Total Studio Counts"
      icon={<img src={FileIcon} />}
      isNoData={isNoData}
      isPercentage={false}
      value={getNumberOfDotUnit(total)}
      slot={renderDetails()}
    />
  );
};

export default React.memo(TotalStudioCountsCard);
